import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Cashbox } from '@/types';
import { useDeleteCashboxMutation } from '@/services';

export interface DeleteCashboxProps extends DialogProps {
  cashbox: Cashbox;
  onClose(): void;
}

const DeleteCashbox: React.FC<DeleteCashboxProps> = ({ cashbox, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteCashbox, deleteCashboxResponse] = useDeleteCashboxMutation();

  async function handleDeleteCashbox() {
    try {
      await deleteCashbox(cashbox).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{cashbox?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{cashbox?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" variant="outlined" disabled={deleteCashboxResponse.isLoading} onClick={onClose}>
          Закрыть
        </Button>

        <Button variant="contained" disabled={deleteCashboxResponse.isLoading} onClick={handleDeleteCashbox}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCashbox;
